import { Card, styled, Typography } from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  maxWidth                 : '308px',
  border                   : `1px solid ${theme.palette.primary.gray3}`,
  borderRadius             : '10px',
  boxSizing                : 'border-box',
  boxShadow                : 'none',
  '& .MuiCardContent-root' : {
    padding        : '20px 21px',
    display        : 'flex',
    flexDirection  : 'column',
    justifyContent : 'space-between',
    minHeight      : '280px',
    boxSizing      : 'border-box',
  },
  '& .MuiCardActions-root' : {
    padding : '20px 21px',
  },
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  color        : theme.palette.primary.grey7,
  fontFamily   : 'Montserrat',
  fontWeight   : '700',
  marginBottom : '8px',
}));

export const Description = styled(Typography)(({ theme }) => ({
  color        : '#231F20',
  fontFamily   : 'Montserrat',
  marginBottom : '8px',
}));

export const DurationTime = styled('div')(({ theme }) => ({
  display    : 'flex',
  alignItems : 'center',
  marginTop  : '8px',
  '& span'   : {
    color      : '#959595',
    fontFamily : 'Montserrat',
    marginLeft : '8px',
  },
}));

export const FirstContentRow = styled('div')({});
export const SecondContentRow = styled('div')({});

export const StyledProgress = styled('div')(({ theme }) => ({
  textAlign : 'center',
  '& span'  : {
    fontFamily : '',
    fontWeight : '700',
    color      : theme.palette.primary.greenPKD,
  },
}));

export const Completed = styled('div')({
  marginTop  : '8px',
  display    : 'flex',
  alignItems : 'center',
  span       : {
    color : '#3AA203',
  },
  '& svg' : {
    width       : '17px',
    height      : '17px',
    marginRight : '8px',
  },
});
